<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table #importTable (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns"
                  [dataProviderParams]="params" [dataProvider]="importService" [title]="'Imports'"
                  [searchColumns]="searchColumns"></data-table>
</page-content>
